
const MAX_TEXT_LEN:number=20;

export enum TitleError{
	None='NONE',
	Short='SHORT',
	Already='ALREADY'
}

export const ContentSetTitle=function(props:{showTitle:boolean,titleError:TitleError, myTitle:string, isContentSetNew:boolean, updateContentSetTitle:Function}){
	if(props.showTitle===false)return null;
	let editDisabled=!props.isContentSetNew;
	let inputClassName='teachers-contentset-title-notnew';
	if(props.isContentSetNew)inputClassName='teachers-contentset-title-new';
	let invalidMsg='';
	if(props.titleError===TitleError.Already)invalidMsg='*Already exists';
	if(props.titleError===TitleError.Short&&props.myTitle.length>0)invalidMsg='*Minimum of 3 characters';
	let cleanTitle=props.myTitle.replace(/_/g,' ');
	return(
		<div>
			<input type='text' placeholder='Enter a title' disabled={editDisabled}
			className={inputClassName} value={cleanTitle} maxLength={MAX_TEXT_LEN} onChange={(e)=>{props.updateContentSetTitle(e.target.value);}}></input>
			{invalidMsg!==''&&<p className='teachers-contenttitle-note'>{invalidMsg}</p>}
		</div>
	)
};

export const checkContentTitle=function(isContentSetNew:boolean, newContentSetTitle:string, userContentList:string[]){
    if(isContentSetNew===false)return TitleError.None;
    if(newContentSetTitle.length<3)return TitleError.Short;
    let lowerCaseTitle=newContentSetTitle.toLowerCase();
    for(let i=0;i<userContentList.length;i++){
        if(userContentList[i].toLowerCase()===lowerCaseTitle)return TitleError.Already;
    }
    return TitleError.None;
};